import { FotosService } from './../../service/fotos.service';
import { Foto } from './../../model/foto';
import { Message, ConfirmationService, MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-fotos',
  templateUrl: './admin-fotos.component.html',
  styleUrls: ['./admin-fotos.component.css']
})
export class AdminFotosComponent implements OnInit {
  uploadPercent: Observable<number>;
  msgs: Message[] = [];
  itens: Observable<Foto[]>;
  public page$;
  constructor(private service: FotosService, private confirmationService: ConfirmationService, private messageService: MessageService) { }

  ngOnInit() {
    this.itens = this.service.paginacao();
    this.page$ = this.service.currentPage$;
  }

  uploadFile(event, form) {
    event.files.forEach(file => {
      const task = this.service.upload(file);
      // observe percentage changes
      this.uploadPercent = this.service.uploadPercent;
      task.then(ret => {
        const tasksalvar = this.service.salvar(ret);
      });
      form.clear();
      this.itens = this.service.paginacao();
    });
  }

  excluir(id) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o registro?',
      accept: () => {
        const task = this.service.delete(id);
        task.then(ret => {
          this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro Excluido com Sucesso' });
        }).catch(e => {
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Excluir' });
        });
      }
    });
  }

  proximaPagina() {
    this.service.proximaPagina();
    this.page$ = this.service.currentPage$;
  }

  paginaAnterior() {
    this.service.paginaAnterior();
    this.page$ = this.service.currentPage$;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-fotos/admin-fotos.component.ts